import { Sidebar as CloudSidebar } from '@itential/cloud-portal-sidebar';
import { useLocation, useNavigate } from 'react-router';
import { useAuthenticatedCloudUser } from '@itential/cloud-auth-client';
import { JSXElement } from '@/common/types';
import { env } from '@/utils/shared/env';

export const Sidebar = (): JSXElement => {
    const location = useLocation();
    const navigate = useNavigate();

    const { hubToken, controlToken } = useAuthenticatedCloudUser();

    return (
        <CloudSidebar
            controlToken={controlToken}
            hubToken={hubToken}
            hubUrl={env.VITE_HUB_URL}
            location={location}
            onNavigate={navigate}
        />
    );
};
